// extracted by mini-css-extract-plugin
module.exports = {"box-shadow":"_3FaVkL6BK8xFzNbUgnDLME","tippy-popper":"_1HPoekmkpR_dhctfONu4Cv","bootstrap-theme":"_36xWgDWQvyJKbtMYVcpRL1","tippy-arrow":"_3waT0AUjOKRCAlPvUxpJyR"};